var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3413 1.58325V4.0629C16.3413 4.29554 16.0504 4.40086 15.9015 4.22214C14.4519 2.60252 12.3453 1.58325 10.0007 1.58325C5.62839 1.58325 2.08398 5.12766 2.08398 9.49992C2.08398 13.8721 5.62839 17.4166 10.0007 17.4166C14.3729 17.4166 17.9173 13.8721 17.9173 9.49992",
    stroke: "var(--primary-color)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.f0de77606df3ca22fc850a80b2345398.svg";
export { ForwardRef as ReactComponent };